import { Sport } from "../../sport-slice";
import { PlayPayloadBase, PlayPayloadProperties } from "./play-payload-generic";

export enum HockeyDrawingArea {
  FULL = 1,
  LEFT_RINK = 2,
  RIGHT_RINK = 3,
  GOAL = 4,
  LEFT_ONE_THIRD = 5,
  RIGHT_ONE_THIRD = 6,
  LEFT_TWO_THIRD = 7,
  RIGHT_TWO_THIRD = 8,
}

export interface PlayPayloadHockey extends PlayPayloadBase {
  sport: Sport.HOCKEY;
  drawingArea?: HockeyDrawingArea;
  properties?: Partial<PlayPayloadProperties>;
}
